<footer class="footer">
    <p class="copyright-msg text-center">Copyright © Cereus Software {{currentYear}} All Rights Reserved.</p>
</footer>
